// extracted by mini-css-extract-plugin
export default {"Logo":"Logo_Logo__Bruj8","Logo__mobile":"Logo_Logo__mobile__7WRiB","Logo__desktop":"Logo_Logo__desktop__2l+6j"};